import protoRoot from "../proto-root";

function create({ state, level }) {
  const BatteryStatus = protoRoot.lookupType(`comm.BatteryStatus`);
  const BatteryState = BatteryStatus.lookupEnum("BatteryState");

  const batteryStatus = BatteryStatus.create({
    level,
    state: BatteryState.values[state]
  });

  return batteryStatus;
}

export default {
  create
};

// message BatteryStatus {
//     enum BatteryState {
//         CHARGING = 0;
//         DISCHARGING = 1;
//         UNKNOWN = 2;
//     }
//     BatteryState state = 1;
//     int32 level = 2;
// }
